module.exports = __webpack_public_path__ + "img/Afspraak.f9d0bdd0.png";